"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitButton = exports.SubmitButtonWrapper = exports.QuestionMarkWrapper = exports.RequiredWrapper = exports.RedText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
exports.RedText = styled_components_1.default.span `
	color: #f6512c;
	line-height: 1;
	content: '*';
	font-size: 14px;
	font-family: SimSun, sans-serif;
	margin-right: 4px;
	display: inline-block;
`;
exports.RequiredWrapper = styled_components_1.default.div `
	padding-top: 2rem;
	border-top: 1px solid ${({ theme }) => theme.color.gray3};
	text-align: center;
	display: flex;
	justify-content: center;
`;
exports.QuestionMarkWrapper = styled_components_1.default.div `
	margin-top: 5.2px;
`;
exports.SubmitButtonWrapper = styled_components_1.default.div `
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	margin: 2.5rem 0 4rem 0;
`;
exports.SubmitButton = (0, styled_components_1.default)(elements_1.Button) `
	flex: 0 0 auto;

	&.ant-btn[disabled],
	&.ant-btn[disabled]:hover,
	&.ant-btn[disabled]:focus,
	&.ant-btn[disabled]:active {
		opacity: 0.5;
		cursor: not-allowed;
		pointer-events: auto;
	}
`;
